import {Component, OnInit, ViewChild} from '@angular/core';

@Component({
    selector: 'i-home',
    template: ``
})

export class HomeCP implements OnInit {
    ngOnInit() {}
}